export const standardFieldsLabels = {
  mobile_phone: I18n.t('web.networks.events.tickets.list.phone_number'),
  company_name: I18n.t('web.networks.events.tickets.list.company_name'),
  custom_field_1: I18n.t('web.networks.events.tickets.list.custom_field_1'),
  custom_field_2: I18n.t('web.networks.events.tickets.list.custom_field_2'),
  custom_field_3: I18n.t('web.networks.events.tickets.list.custom_field_3'),
};
